import { Cookies } from 'react-cookie';

import { EmployeeFormData, userOnClientCreationResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const addEmployeeForClient = async (employee: EmployeeFormData) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.post('clients/create-client-employee/', employee, {
    headers: {
      Authorization: token,
    },
  });
  return response.data as userOnClientCreationResponse;
};
